"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const navigation_1 = __importDefault(require("@App/navigation"));
const MatchingHelperText = () => (react_1.default.createElement("div", { className: "no-results-text" },
    react_1.default.createElement("p", null, "It looks like we couldn't locate any results for the search terms."),
    react_1.default.createElement("p", null, "Double-check your search terms or try searching again using other criteria."),
    react_1.default.createElement("br", null),
    react_1.default.createElement("p", null, "If you're still having trouble finding the recording, it may be that:"),
    react_1.default.createElement("li", null, "The MLC has not received any usage data from the DSPs for this recording."),
    react_1.default.createElement("li", null, "This recording has already been matched to the work. Try locating the work in the Public Search to see if it has already been matched."),
    ' ',
    react_1.default.createElement("br", null),
    react_1.default.createElement("p", null,
        "If you still need help, ",
        react_1.default.createElement(react_router_dom_1.Link, { to: navigation_1.default.contactUs.root() }, "contact us"),
        ".")));
exports.default = MatchingHelperText;
